import React, { useContext, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { UserContext } from "../../reuseableComponents/auth/UserContext";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import { LOAD_FILE_UPLOAD_REVIEW_DATA } from "../../../queries/archiveQrys/secureQrys/fileUploadMgmtQrys";
import FileUploadReviewForm from "./FileUploadReviewForm";
import { appConfig } from "../../../configuration/AppConfig";

const FileUploadReviewPage = (props) => {
  const { user } = useContext(UserContext);
  const [s3Error, setS3Error] = useState(null);
  const bucketName = appConfig.bucketName;
  const { loading, error, data } = useQuery(LOAD_FILE_UPLOAD_REVIEW_DATA);
  const { item } = props.location?.state || {};
  if (!item) {
    return (
      <div className='page-container file-upload-review-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h1 className="main-section-title">File Upload Management</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='alert alert-warning mt-4'>
              No file selected for review. Please return to the file upload list and select a file.
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  async function handleFileDownload(fileDetails) {
    //Check file size
    if (fileDetails.fileSize >= 5 * 1024 * 1024) {
      await fetch(`${appConfig.s3GetPresignedUrl}?fileName=${fileDetails.filePath}&bucketName=${bucketName}`)
        .then((res) => res.json())
        .then((data) => window.open(data.url, "_blank").focus());
    } else {
      await fetch(`${appConfig.s3FileDownload}?fileName=${fileDetails.filePath}&bucketName=${bucketName}`).then(
        (response) => {
          if (response.status === 200) {
            response.blob().then((myBlob) => {
              const objectURL = URL.createObjectURL(myBlob);
              const link = document.createElement("a");
              link.href = objectURL;
              link.setAttribute("download", fileDetails.fileName);
              document.body.appendChild(link);
              link.click();
            });
          } else {
            response.json().then((data) => {
              setS3Error("ERROR: " + JSON.stringify(data["message"]));
            });
          }
        }
      );
    }
  }
  if (loading) {
    return (
      <div className='page-container file-upload-review-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h1 className="main-section-title">File Upload Management</h1>
            </HeaderBox>
          </Col>
        </Row>
        {item ? (
          <>
            <Row>
              <Col>
                <br />
                <span>
                  <b>Submitted:</b> {item.createdBy} on {convertTimeStampToDate(item.createdOn)}
                </span>
                <br />
                <span>
                  <b>Document: </b>
                </span>
                <button
                  type='button'
                  onClick={() => handleFileDownload(item)}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "#157995",
                    textDecoration: "underline",
                    cursor: "pointer",
                    minHeight: "44px"
                  }}
                >
                  {item.fileName}
                </button>
                <br />
                <span>
                  <b>Reason for Upload: </b> {item.fileDescription}
                </span>
                <br />
              </Col>
            </Row>
            <Row>
              <Col>
                <span className='error' role="alert">{s3Error}</span>
              </Col>
            </Row>
          </>
        ) : (
          ""
        )}
        <br />
        <Row>
          <Col>
            <SkeletonLoader width='100%' />
          </Col>
        </Row>
      </div>
    );
  }
  if (error) {
    return (
      <div className='page-container file-upload-review-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
              <h1 className="main-section-title">File Upload Management</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className='page-container file-upload-review-container'>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='fileUploadMgmtPage'>
            <h1 className="main-section-title">File Upload Management</h1>
          </HeaderBox>
        </Col>
      </Row>
      {item ? (
        <>
          <Row>
            <Col>
              <span>
                <b>Submitted:</b> {item.createdBy} on {convertTimeStampToDate(item.createdOn)}
              </span>
              <br />
              <span>
                <b>Document Name: </b>
              </span>
              <button
                type='button'
                onClick={() => handleFileDownload(item)}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  color: "#157995",
                  textDecoration: "underline",
                  cursor: "pointer",
                  minHeight: "44px"
                }}
              >
                {item.fileName}
              </button>
              <br />
              <span>
                <b>Reason for Upload: </b> {item.fileDescription}
              </span>
              <br />
              <br />
            </Col>
          </Row>
          <Row>
            <Col>
              <span className='error' role="alert">{s3Error}</span>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      <Row>
        <Col>
          {item ? (
            <FileUploadReviewForm
              user={user}
              fileMetadata={item}
              systems={data.getWaterSystemMenu}
              fileTypes={data.getFileUploadFileTypes}
              subTypes={data.getListofDocSubTypesForDropdown}
              status={data.getAcceptRejectPending}
            />
          ) : (
            <p>No file selected. Please navigate here from the File Upload Management page.</p>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FileUploadReviewPage;
